import React, { useEffect, useState } from 'react';

import { Form, Table, Typography, VertButton } from '@vertem-core/vertice-ds';

import 'Assets/styles/default/pages/concierge/NewConciergeSolicitationStyles.less';

import RemoveIcon from 'components/Concierge/Icons/remove';
import Edit from 'components/Concierge/Icons/edit';
import Search from 'components/Concierge/Icons/search';

import { Col, Row } from 'antd';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { LuArrowRight } from 'react-icons/lu';

import PropTypes from 'prop-types';
import dayjs from 'dayjs';

import DeleteConciergeItemModal from '../Modals/DeleteConciergeItemModal';
import ViewDetailsConciergeItemModal from '../Modals/ViewDetailsConciergeItemModal';
import FormInformation from './FormInformation';
import ErrorApiModal from '../Modals/ErrorApiModal';

import { pointsMask } from 'Utils/commons/points';
import { shouldConvertToPoints } from 'Constants/Concierge';
import { convertNumberToStringCurrency } from 'Utils/convertPoints';

import { SolicitationItemInitialState } from 'Constants/Concierge/initialStateValues';
import { getRequestSubcategoryFormThunk } from 'redux/Reducers/Concierge/requestSubcategoryFormSlicer';

const SolicitationInformation = ({ ...props }) => {
    const {
        solicitation,
        setSolicitation,
        userPoints,
        handleNextStep,
        handlePreviousStep,
    } = props;

    const columns = [
        {
            title: 'Produto/serviço',
            dataIndex: 'title',
            className: 'table-col-vertical-align',
            width: '30%',
            align: 'center'
        },
        {
            title: 'Valor Unitário',
            className: 'table-col-vertical-align',
            align: 'center',
            render: (_, { unitValue, pointsValue }) => (
                <Row>
                    {
                        !unitValue && !(shouldConvertToPoints && pointsValue) && (
                            <Col span={24}>
                                <Typography.Text className='span-cell-content'>
                                    -
                                </Typography.Text>
                            </Col>
                        )
                    }

                    {
                        unitValue && (
                            <Col span={24}>
                                <Typography.Text className='span-cell-content'>
                                    {convertNumberToStringCurrency(unitValue)}
                                </Typography.Text>
                            </Col>
                        )
                    }

                    {
                        (shouldConvertToPoints && pointsValue) && (
                            <Col span={24}>
                                <Typography.Text className='span-cell-content'>
                                    {wrapperPoints(pointsValue)} {pointsName}
                                </Typography.Text>
                            </Col>
                        )
                    }
                </Row >
            ),
        },
        {
            title: 'Qtd.',
            dataIndex: 'quantity',
            align: 'center',
            className: 'table-col-vertical-align'
        },
        {
            title: 'Total',
            align: 'center',
            className: 'table-col-vertical-align',
            render: (_, { unitValue, quantity, pointsTotalValue = null }) => (
                <Row>
                    {
                        !unitValue && !(shouldConvertToPoints && pointsTotalValue) && (
                            <Col span={24}>
                                <Typography.Text className='span-cell-content'>
                                    -
                                </Typography.Text>
                            </Col>
                        )
                    }

                    {
                        unitValue && (
                            <Col span={24}>
                                {convertNumberToStringCurrency(parseFloat(unitValue.replace(',', '.')) * quantity)}
                            </Col>
                        )
                    }

                    {
                        (shouldConvertToPoints && pointsTotalValue) && (
                            <Col span={24}>
                                {wrapperPoints(pointsTotalValue)} {pointsName}
                            </Col>
                        )
                    }
                </Row>
            ),
        },
        {
            title: 'Ações',
            align: 'center',
            className: 'table-col-vertical-align',
            render: (_, item) => (
                <Row gutter={8} justify={'space-evenly'} align={'middle'}>
                    <Col onClick={() => {
                        setIdDelete(item.id);
                        setIsOpenModalDeleteConciergeItem(true);
                    }}>
                        <RemoveIcon />
                    </Col>
                    <Col onClick={() => handleEditConciergeItem(item)}>
                        <Edit />
                    </Col>
                    <Col onClick={() => handleViewDetailsConciergeItem(item)}>
                        <Search />
                    </Col>
                </Row>
            ),
        }
    ];

    const columnsBillPayment = [
        {
            title: 'Tipo de conta',
            dataIndex: 'subCategoryLabel',
            className: 'table-col-vertical-align',
            width: '30%',
            align: 'center'
        },
        {
            title: 'Valor',
            dataIndex: 'pointsValue',
            className: 'table-col-vertical-align',
            align: 'center',
            render: (_, { pointsValue, unitValue }) => (

                <Row>

                    {
                        !pointsValue && !unitValue &&
                        <Col span={24}>
                            <Typography.Text className='span-cell-content'>
                                -
                            </Typography.Text>
                        </Col>
                    }

                    {
                        unitValue &&
                        <Col span={24}>
                            <Typography.Text className='span-cell-content'>
                                {convertNumberToStringCurrency(unitValue)}
                            </Typography.Text>
                        </Col>
                    }

                    {
                        pointsValue &&
                        <Col span={24}>
                            <Typography.Text className='span-cell-content'>
                                {wrapperPoints(pointsValue)} {pointsName}
                            </Typography.Text>
                        </Col>
                    }

                </Row >
            ),
        },
        {
            title: 'Data',
            dataIndex: 'date',
            align: 'center',
            className: 'table-col-vertical-align',
            render: (_, { date }) => (
                <Row>
                    <Col span={24}>
                        {dayjs(date).format('DD/MM/YYYY')}
                    </Col>
                </Row>
            )
        },
        {
            title: 'Total',
            align: 'center',
            className: 'table-col-vertical-align',
            render: (_, { unitValue, pointsValue }) => (
                <Row>
                    {
                        unitValue &&
                        <Col span={24}>
                            {convertNumberToStringCurrency(parseFloat(unitValue.replace(',', '.')))}
                        </Col>
                    }

                    {
                        pointsValue &&
                        <Col span={24}>
                            {wrapperPoints(pointsValue)} {pointsName}
                        </Col>
                    }
                </Row>
            ),
        },
        {
            title: 'Ações',
            align: 'center',
            className: 'table-col-vertical-align',
            render: (_, item) => (
                <Row gutter={8} justify={'space-evenly'} align={'middle'}>
                    <Col onClick={() => {
                        setIdDelete(item.id);
                        setIsOpenModalDeleteConciergeItem(true);
                    }}>
                        <RemoveIcon />
                    </Col>
                    <Col onClick={() => handleEditConciergeBillPayment(item)}>
                        <Edit />
                    </Col>
                </Row>
            ),
        }
    ];

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [form] = Form.useForm();

    const [currentProductService, setCurrentProductService] = useState(SolicitationItemInitialState);
    const [productDetails, setProductDetails] = useState(SolicitationItemInitialState);
    const [isEditingProductService, setIsEditingProductService] = useState(false);
    const [isOpenModalDeleteConciergeItem, setIsOpenModalDeleteConciergeItem] = useState(false);
    const [idDelete, setIdDelete] = useState("");
    const [isOpenModalDetails, setIsOpenModalDetails] = useState(false);
    const [editingProductServiceTotalPoints, setEditingProductServiceTotalPoints] = useState();
    const [isOpenModalErrorApi, setIsOpenModalErrorApi] = useState(false);
    const [subCategoryList, setSubCategoryList] = useState([]);
    const [showForm, setShowForm] = useState(true);
    
    const Catalog = useSelector(({ Catalog: data }) => data);
    const { currencyConfiguration: { decimalPlaces, pointsName } } = Catalog;

    const {
        dataRequestCategory,
        loadingRequestCategory,
        errorRequestCategory
    } = useSelector(
        (state) => state.RequestCategory
    );

    const sumTotalUnitValue = () => {
        return convertNumberToStringCurrency(
            solicitation.productList?.filter(a => a.unitValue)
                .map(a => parseFloat(a.unitValue.replace(',', '.')) * (solicitation.isBillPayment ? 1 : a.quantity))
                .reduce((total, number) => total + number, 0)
        );
    }

    const sumTotalPointsValue = () => {
        return solicitation.productList?.filter(a => a.pointsValue)
            .map(a => (a.pointsValue * (solicitation.isBillPayment ? 1 : a.quantity)))
            .reduce((total, number) => total + number, 0);
    }

    const handleEditConciergeItem = (item) => {
        var currentCategory = dataRequestCategory.find(x => x.id == item.category);

        setSubCategoryList(
            currentCategory.subcategories.map(subcategory => ({
                value: subcategory.id,
                label: subcategory.name,
                name: subcategory.name
            }))
        );

        form.setFieldsValue(
            {
                category: item.category,
                subCategory: item.subCategory,
                title: item.title,
                quantity: item.quantity,
                unitValue: item.unitValue,
                pointsValue: item.pointsValue?.toLocaleString("pt-BR") || '0',
                pointsTotalValue: item.pointsTotalValue?.toLocaleString("pt-BR") || '0',
                description: item.description,
            }
        )

        dispatch(getRequestSubcategoryFormThunk(item.subCategory));

        const itemTotalValue = shouldConvertToPoints ? item.pointsTotalValue : (Number(item.quantity) * item.pointsValue);

        setEditingProductServiceTotalPoints(solicitation.isBillPayment ? item.pointsValue : itemTotalValue);
        setCurrentProductService(item);
        setIsEditingProductService(true);
        setShowForm(true);
    }

    const handleEditConciergeBillPayment = (item) => {
        setSubCategoryList(subCategoryList)

        form.setFieldsValue(
            {
                pointsValue: item.pointsValue.toLocaleString("pt-BR"),
                subCategory: item.subCategory,
                unitValue: item.unitValue,
                barCode: item.barCode,
                date: item.date,
            }
        )

        setEditingProductServiceTotalPoints(item.pointsValue);
        setCurrentProductService(item);
        setIsEditingProductService(true);
        setShowForm(true);
    }

    const handleViewDetailsConciergeItem = (item) => {
        const product = {
            ...item,
            category: item.categoryLabel,
            subCategory: item.subCategoryLabel,
            pointsValue: item.pointsValue?.toLocaleString("pt-BR") || '0',
            pointsTotalValue: item.pointsTotalValue?.toLocaleString("pt-BR") || '0',
            quantity: item.quantity.toString(),
        };

        setProductDetails(product);
        setIsOpenModalDetails(true);
    }

    const deleteItem = (idDelete) => {
        var newList = solicitation.productList?.filter(x => x.id != idDelete);
        setSolicitation((solicitation) => ({
            ...solicitation,
            productList: newList
        }))
        if (!newList.length) {
            return setShowForm(true);
        }
    }

    const continueStep = () => {
        handleNextStep(solicitation);
    }

    const wrapperPoints = (points) => {
        return pointsMask(points, decimalPlaces, pointsName).value;
    }

    useEffect(() => {
        if (errorRequestCategory)
            setIsOpenModalErrorApi(true);
    }, [errorRequestCategory]);

    useEffect(() => {
        if (solicitation.productList?.length)
            setShowForm(false);
    }, []);

    return (
        <>
            {
                showForm ?
                    <FormInformation
                        solicitation={solicitation}
                        setSolicitation={setSolicitation}
                        userPoints={userPoints}
                        setShowForm={setShowForm}
                        form={form}
                        currentProductService={currentProductService}
                        setCurrentProductService={setCurrentProductService}
                        isEditingProductService={isEditingProductService}
                        setIsEditingProductService={setIsEditingProductService}
                        editingProductServiceTotalPoints={editingProductServiceTotalPoints}
                        subCategoryList={subCategoryList}
                        setSubCategoryList={setSubCategoryList}
                        handlePreviousStep={handlePreviousStep}
                    />
                    :
                    <div className='margin-top-big'>
                        <Row gutter={[36, 28]}>
                            <Col span={24}>
                                <VertButton
                                    disabled={solicitation.isBillPayment}
                                    type='default'
                                    size="default"
                                    className='button-concierge'
                                    htmlType="button"
                                    onClick={() => setShowForm(true)}
                                >
                                    <Typography.Text className='span-button'>
                                        Adicionar novo produto/serviço
                                    </Typography.Text>
                                </VertButton>
                            </Col>

                            <Col span={24} >
                                <Typography.Text className='text-subtitle'>
                                    Produto/serviço adicionado
                                </Typography.Text>
                            </Col>

                            <Col xs={24} sm={24} md={24} lg={19} xl={19} >
                                <Table
                                    className='table-product-service-concierge'
                                    pagination={false}
                                    columns={solicitation.isBillPayment ? columnsBillPayment : columns}
                                    rowKey={(record) => record.id}
                                    bordered
                                    dataSource={solicitation.productList}
                                    scroll={{ x: "1024px" }}
                                />

                            </Col>

                            {shouldConvertToPoints && (
                                <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                                    <div className='container-summary-product'>
                                        <Row gutter={[8, 8]}>
                                            <Col span={24} className='padding-bottom-title'>
                                                <Typography.Text className='text-subtitle'>Resumo da solicitação</Typography.Text>
                                            </Col>

                                            <Col span={24}>
                                                <Row justify={'space-between'}>
                                                    <Col span={24}>
                                                        <Typography.Text strong>
                                                            Total em dinheiro:
                                                        </Typography.Text>
                                                    </Col>

                                                    <Col>
                                                        <Typography.Text>
                                                            {sumTotalUnitValue()}
                                                        </Typography.Text>
                                                    </Col>
                                                </ Row>
                                            </Col>

                                            {
                                                (shouldConvertToPoints || solicitation.isBillPayment) && (
                                                    <Col span={24}>
                                                        <Row justify={'space-between'}>
                                                            <Col span={24}>
                                                                <Typography.Text strong>
                                                                    Total em {pointsName}:
                                                                </Typography.Text>
                                                            </Col>

                                                            <Col>
                                                                <Typography.Text>
                                                                    {wrapperPoints(sumTotalPointsValue())} {pointsName}
                                                                </Typography.Text>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                )
                                            }
                                        </Row>
                                    </div>
                                </Col>
                            )}

                            <Row gutter={[8, 8]} className='margin-top-big width-100' justify={'end'}>
                                {
                                    !solicitation.redemptionId &&
                                    <Col>
                                        <VertButton
                                            className='button-continue button-concierge'
                                            type='default'
                                            size="default"
                                            onClick={() => handlePreviousStep()}
                                        >
                                            <Typography.Text className='span-button-return'>
                                                Voltar
                                            </Typography.Text>
                                        </VertButton>
                                    </Col>
                                }

                                <Col className='collum-btn-continue'>
                                    <VertButton
                                        className='button-continue width-100 button-concierge'
                                        type='highlight'
                                        size="default"
                                        htmlType="button"
                                        onClick={continueStep}
                                    >
                                        <Typography.Text className='span-button-continue'>
                                            Continuar
                                        </Typography.Text>
                                        <LuArrowRight />
                                    </VertButton>
                                </Col>
                            </Row>
                        </Row>

                    </div>
            }

            <DeleteConciergeItemModal
                isOpen={isOpenModalDeleteConciergeItem}
                onClose={() => setIsOpenModalDeleteConciergeItem(false)}
                deleteItem={() => deleteItem(idDelete)}
            />

            <ViewDetailsConciergeItemModal
                isOpen={isOpenModalDetails}
                onClose={() => { setIsOpenModalDetails(false) }}
                item={productDetails}
            />

            <ErrorApiModal
                isOpen={isOpenModalErrorApi}
                onClose={() => navigate("/list-solicitations")}
            />
        </>
    )
}

SolicitationInformation.propTypes = {
    solicitation: PropTypes.object.isRequired,
    setSolicitation: PropTypes.func.isRequired,
    handleNextStep: PropTypes.func.isRequired,
    handlePreviousStep: PropTypes.func.isRequired,
    userPoints: PropTypes.number.isRequired,
};

export default SolicitationInformation;
